import { Grid } from '@material-ui/core';
import {
  Event as EventIcon,
  HomeWorkRounded as HomeWorkIcon,
  SchoolRounded as SchoolIcon,
  Work as WorkIcon,
} from '@material-ui/icons';
import { getStudentAffiliate, getTrainingById } from '@webapps/business';
import { useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import ReformatDate from 'assets/ReformatDate';
import Team from 'components/Icons/Team';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

const School = ({ UserId, typeOrganism }) => {
  const { classes, global, cx } = useStyles(styles);

  // const [affiliationsFilter, setAffiliationFilter] = useState([]);

  const {
    data: { data: affiliations = [] } = {},
    isLoading: isLoadingAffiliation,
  } = useQuery(getStudentAffiliate, {
    key: ['studentAffiliateDashboard', UserId],
    variables: { id: UserId, type: 'school', status: 'ENCLOSED' },
  });

  // useEffect(() => {
  //   if (affiliations.length) {
  //     setAffiliationFilter(
  //       affiliations?.filter(({ status }) => status !== 'REJECTED')
  //     );
  //   }
  // }, [isLoadingAffiliation]);

  // const [activeStep] = useState(0);

  // const trainingId = affiliationsFilter[activeStep]?.classroom?.training;

  const { data: training = {} } = useQuery(getTrainingById, {
    key: ['training', affiliations[0]?.classroom?.training],
    variables: { id: affiliations[0]?.classroom?.training },
    enabled: typeof affiliations[0]?.classroom?.training !== 'undefined',
  });

  return (
    <div className={classes.container}>
      <div className={cx(global.title, classes.title)}>Formation</div>
      <div className={classes.infoContainer}>
        {!affiliations?.length &&
        affiliations[0]?.contract?.status === 'BROKEN' ? (
          <div className={classes.noElement}>
            <FormattedMessage id="noElements" />
          </div>
        ) : (
          <Grid container>
            {typeOrganism === 'business' && (
              <div className={classes.cellTable}>
                <div className={cx(global.infoText, classes.address)}>
                  {' '}
                  <HomeWorkIcon
                    className={global.infoIcon}
                  />{' '}
                  Nom de l'école :{' '}
                  <span className={classes.span}>
                    {affiliations[0]?.classroom?.school?.name
                      ? affiliations[0]?.classroom?.school?.name
                      : "En attente d'affiliation"}
                  </span>
                </div>
              </div>
            )}

            <div className={classes.cellTable}>
              <div className={cx(global.infoText, classes.address)}>
                {' '}
                <WorkIcon
                  className={global.infoIcon}
                />{' '}
                Formation :{' '}
                <span className={classes.span}>
                  {training?.label
                    ? training?.label
                    : "En attente d'affiliation"}
                </span>
              </div>
            </div>
            <div className={classes.cellTable}>
              <div className={cx(global.infoText, classes.address)}>
                {' '}
                <SchoolIcon
                  className={global.infoIcon}
                />{' '}
                Niveau de diplôme :{' '}
                <span className={classes.span}>
                  {training?.degree?.label
                    ? training?.degree?.label
                    : "En attente d'affiliation"}
                </span>
              </div>
            </div>
            <div className={classes.cellTable}>
              <div className={cx(global.infoText, classes.address)}>
                {' '}
                <EventIcon
                  className={global.infoIcon}
                />{' '}
                Date d'entrée :{' '}
                <span className={classes.span}>
                  <ReformatDate
                    inputDate={
                      affiliations[0]?.classroom?.startDate
                        ? affiliations[0]?.classroom?.startDate
                        : "En attente d'affiliation"
                    }
                  />
                </span>
              </div>
            </div>
            <div className={classes.cellTable}>
              <div className={cx(global.infoText, classes.address)}>
                {' '}
                <EventIcon
                  className={global.infoIcon}
                />{' '}
                Date de fin :{' '}
                <span className={classes.span}>
                  <ReformatDate
                    inputDate={
                      affiliations[0]?.classroom?.endDate
                        ? affiliations[0]?.classroom?.endDate
                        : "En attente d'affiliation"
                    }
                  />
                </span>
              </div>
            </div>
          </Grid>
        )}
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    borderLeft: '3px solid #0060F9',
    paddingLeft: spacing(1),
    marginBottom: spacing(1.5),
  },
  noElement: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    marginTop: spacing(2),
    color: '#5D75A8',
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: spacing(1),
    '@media (max-width: 430px)': {
      flexDirection: 'column',
    },
  },
  span: {
    color: '#152652',
    marginLeft: spacing(0.5),
  },
  cellTable: {
    width: '100%',
  },
});

School.propTypes = {
  UserId: PropTypes.string,
};

export default School;
